module.exports = __webpack_public_path__ + "img/thunder-g.4b886fd7.svg";